import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'

Vue.use(Router)

var router = new Router({
        mode: 'history',
        base: '/user',
        routes: [
            { path: '/', redirect: '/login' },
            {
                path: '/login',
                name: 'Login',
                component: resolve => require(['../components/Login'], resolve),
                meta: {
                    title: '云告账号登录—云告官网'
                }
            },
            {
                path: '/registerlogin',
                name: 'RegisterLogin',
                component: resolve => require(['../components/RegisterLogin'], resolve),
                meta: {
                    title: '云告注册新用户—云告官网'
                }
            },
            {
                path: '/forgetlogin',
                name: 'forgetlogin',
                component: resolve => require(['../components/ForgetLogin'], resolve),
                meta: {
                    title: '云告忘记密码—云告官网'
                }
            },
            {
                path: '/activationuser',
                name: 'Activationuser',
                component: resolve => require(['../components/Activationuser'], resolve),
                meta: {
                    title: '云告账号激活—云告官网'
                }
            },
            // 后台
            {
                path: '/home',
                component: resolve => require(['../components/Home'], resolve),
                redirect: '/first',
                children: [
                    // 首页
                    {
                        path: '/first',
                        component: resolve => require(['../components/First'], resolve),
                        meta: {
                            title: '云告—首页'
                        }
                    },
                    {
                        path: '/app',
                        component: resolve => require(['../components/App'], resolve),
                        meta: {
                            title: '云告—应用管理'
                        }
                    },
                    {
                        path: '/code',
                        component: resolve => require(['../components/Code'], resolve),
                        meta: {
                            title: '云告—代码位管理'
                        }
                    },
                    {
                        path: '/astrict',
                        component: resolve => require(['../components/Astrict'], resolve),
                        meta: {
                            title: '云告—投放屏蔽'
                        }
                    },
                    {
                        path: '/dataApp',
                        component: resolve => require(['../components/DataApp'], resolve),
                        meta: {
                            title: '云告—应用'
                        }
                    },
                    {
                        path: '/dataCode',
                        component: resolve => require(['../components/DataCode'], resolve),
                        meta: {
                            title: '云告—代码位'
                        }
                    },
                    {
                        path: '/finance',
                        component: resolve => require(['../components/Finance'], resolve),
                        meta: {
                            title: '云告—财务'
                        }
                    },
                    {
                        path: '/download',
                        component: resolve => require(['../components/Download'], resolve),
                        meta: {
                            title: '云告—下载中心'
                        }
                    },
                    {
                        path: '/message',
                        component: resolve => require(['../components/Message'], resolve),
                        meta: {
                            title: '云告—消息中心'
                        }
                    },
                    {
                        path: '/userInfo',
                        component: resolve => require(['../components/UserInfo'], resolve),
                        meta: {
                            title: '云告—账户管理'
                        }
                    }
                ]
            }
        ]
    })
    // 路由导航守卫， 检测token如果不存在， 就跳转到login登录组件去
router.beforeEach((to, from, next) => {
    // 访问/login 就直接pass
    if (to.path === '/login') {
        return next()
    }
    if (to.path === '/registerlogin') {
        return next()
    }
    if (to.path === '/forgetlogin') {
        return next()
    }
    if (to.path === '/userInfo') {
        return next()
    }
    if (to.path === '/activationuser') {
        return next()
    }
    // 访问非login，判断token
    // var token = window.sessionStorage.getItem('token')
    var token = Cookies.get('token')
    if (!token || token === -1) {
        return next('/login')
    }
    next() // token存在，继续....
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js